import React, { useCallback } from "react";

//хук управления формой
export function useForm() {
  const [values, setValues] = React.useState({});

  const handleChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  };

  return { values, handleChange, setValues };
}

//хук управления формой и валидации формы
export function useFormWithValidation() {
  const [values, setValues] = React.useState({});
  const [errors, setErrors] = React.useState({});
  const [isValid, setIsValid] = React.useState(false);

  const phoneRegExp = /^\+?[1-9]\d{1,14}$/; // E.164 формат для телефона
  const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/; // Минимум 8 символов, хотя бы одна буква и одна цифра

  const handleChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;

    let errorMessage = target.validationMessage;

    if (name === "phone" && value) {
      if (!phoneRegExp.test(value)) {
        errorMessage = "Введите корректный номер телефона в международном формате";
       
      } else {
        errorMessage = "";
      }
    }

    if (name === "password" && value) {
      if (!passwordRegExp.test(value)) {
        errorMessage = "Пароль должен содержать минимум 8 символов, хотя бы одну букву и одну цифру";
    
      } else {
        errorMessage = "";
      }
    }


    setValues({ ...values, [name]: value });
    setErrors({ ...errors, [name]: errorMessage });

    if (errorMessage === "" ) {
      setIsValid(target.closest("form").checkValidity());
    } else {
      setIsValid(false);
    }

    


  };

  const resetForm = useCallback(
    (newValues = {}, newErrors = {}, newIsValid = false) => {
      setValues(newValues);
      setErrors(newErrors);
      setIsValid(newIsValid);
    },
    [setValues, setErrors, setIsValid]
  );

  return { values, handleChange, errors, isValid, resetForm };
}
